// A late response from a previous login must not sign out the current user.
let epoch = 0;
const listeners = new Set<() => void>();
export const sessionEpoch = () => epoch;
export const advanceSessionEpoch = () => ++epoch;
export function onSessionExpired(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
export function expireSession(
  requestEpoch: number,
  status: number,
  code?: string,
) {
  if (status !== 401 || code !== "SESSION_INVALID" || requestEpoch !== epoch)
    return false;
  epoch++;
  for (const listener of listeners) listener();
  return true;
}
